import React from 'react';
import GridProps from "./props";
import GridItem from './components/GridItem';
import './style.scss';

function Grid({ cells, items }: GridProps) {
  return (
    <div className='grid' data-e2e='grid'>
      {Array.from({ length: cells }).map((_, index) => {
        const item = items?.[index];
        return (
          <GridItem key={index} index={index}>
            {item?.content || <div>Loading...</div>}
          </GridItem>
        );
      })}
    </div>
  );
}

export default React.memo(Grid);